// The ONE definition of "this row is funded" — shared by the ready gate
// (server/modules/rollouts/readyGateValidation.ts) and the Meta/Google build-grid
// filters (src/lib/passesPlatformGridFilter.ts).
//
// ⚠️⚠️ THESE TWO MUST AGREE, AND ONCE DID NOT. The ready gate has always accepted
// `monthly > 0 || campaignIncrease > 0`, while the grid filters gated on
// `monthly > 0` alone. A row funded ENTIRELY by a campaign increase therefore
// passed the ready gate, showed a valid daily budget, and then never appeared on
// the build screens — the work looked ready and was silently unbuildable, with
// nothing on screen to explain why. Extracted here so the two cannot drift again:
// there is one condition and both import it.
//
// A leaf: types only, no I/O, no imports from either consumer. Both the client
// wire shape and the server stored shape satisfy the signature (monthly is
// nullable in both; the increase fields are required non-null numbers on
// AccountCampaign).
//
// NOTE: src/lib/dailyBudget.ts's computeDailyBudget encodes the same rule from
// the other side — it returns error 'no_budget' when monthly and increase are
// both zero. For any non-negative budget (the only kind the money model
// permits — see the money-is-integer-cents rule) that is exactly
// !hasEffectiveBudget, so the three surfaces agree. It is deliberately left
// phrased its own way rather than rewired, because routing it through this
// helper would also change its behaviour for NEGATIVE inputs, and that is money
// math which no bug requires touching.

// True when the row has money behind it from either source. `monthly` is the
// platform's monthly budget in integer cents (nullable — an unset budget reads
// as no money, not as zero-dollars-deliberately); `increase` is that platform's
// campaign increase in integer cents.
export function hasEffectiveBudget(monthly: number | null | undefined, increase: number): boolean {
  return (monthly ?? 0) > 0 || increase > 0;
}
